module.exports = __webpack_public_path__ + "img/rewards-setup.0970c200.jpg";